import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'
import { setInputRows } from '../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../components/procedure/store/procedure.types'
import { getIntubationSelector } from '../selectors'
import { IntubationConstants } from '../store/intubation.constants'
import { IIntubationState } from '../store/intubation.types'
import { IPNNVOption } from '../../../common/common.types'

export interface IAirwayComplicationPNNVAction {
  type: string
  airwayComplicationsPNNV: IPNNVOption | null
}

export function* setAirwayComplicationsPNNV(action: IAirwayComplicationPNNVAction) {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const intubationState: IIntubationState = yield select(getIntubationSelector)
  const { inputRows } = procedureState
  const { airwayComplications } = intubationState

  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === IntubationConstants.SET_AIRWAY_COMPLICATIONS) {
        //@ts-ignore
        input.props.savedValues = airwayComplications
        //@ts-ignore
        input.props.savedPNNVValue = action.airwayComplicationsPNNV
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setAirwayComplicationsPNNVSaga() {
  yield takeLatest([IntubationConstants.SET_AIRWAY_COMPLICATIONS_PNNV], setAirwayComplicationsPNNV)
}
